<template>
  <router-view />
</template>
<script>
import { Redirect } from "@shopify/app-bridge/actions";
export default {
  created() {
    this.$store.dispatch("initAppBridge").then(app => {
      this.subscribeToNavRedirect(app);
    });
  },
  methods: {
    subscribeToNavRedirect(app) {
      if (app) {
        console.log("app location", location);

        if (location.pathname) {
          if (location.pathname.indexOf("/api/shopify/connect") > -1) {
            this.$router.push({ path: "/overview" });
          } else {
            this.$router.push({ path: location.pathname });
          }
        }

        app.subscribe(Redirect.Action.APP, redirectData => {
          console.log(redirectData.path); // For example, '/settings'
          if (redirectData.path.indexOf("/api/shopify/connect") > -1) {
            this.$router.push({ path: "/overview" });
          } else {
            this.$router.push({ path: redirectData.path });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
